import { combineReducers } from 'redux';
import { dfp_data } from './data';
import { ui } from './ui';
import { noAdInSlot } from './noAdInSlot';

export default combineReducers({
    dfp_data,
    ui,
    noAdInSlot,
});



// WEBPACK FOOTER //
// src/client/components/common/adverts/googleDFP/lib/reducers/index.js